import React from 'react';
import {DescriptiveCPU, DescriptiveGPU} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';
import Table from 'grommet/components/Table';
import TableRow from 'grommet/components/TableRow';
import TableHeader from 'grommet/components/TableHeader';
import Value from 'grommet/components/Value';
import Box from 'grommet/components/Box';
import Tiles from 'grommet/components/Tiles';
import Tile from 'grommet/components/Tile';

class BubbleSample extends React.Component {
    constructor() {
        super();
        this.state = { 
            title: true,
            legends: true,
            exprt: false,
            time: null,
            showcomponent: false,
            finalResult: null
             }
        this._onresult = this._onresult.bind(this)
        this._set2digits = this._set2digits.bind(this)
    }
    componentDidMount() {
        this.setState({showcomponent: true})
    }
    _onresult(event) {
        const {finalResult, time} = event.detail;
        this.setState({time, finalResult})
    }
    _set2digits(value) {
        if (value) {
            return value.toFixed(2)
        } else {
            return null
        }
    }
    _onSelect() {

    }
    _onSort() {

    }
    
    render() {
        const {showcomponent, finalResult, time} = this.state
        let time2digits = this._set2digits(time)
        
        let iterator = (finalResult) ? finalResult : []

        //const dataObjectParsed = this.props.dataObject ? JSON.parse(this.props.dataObject.replace(/(\r\n|\n|\r|\s)/gm,"")) : []
        let finalObjectFiltered = []
        let finalNameFiltered = []
        this.props.dataObject.forEach((input, index) => {
            if (this.props.dataNames[`positiontype${index + 1}`] === "Number" && this.props.positionFilter.indexOf(index) > -1) {
                finalObjectFiltered.push(input)
                finalNameFiltered.push(this.props.dataNames[`positionname${index+1}`])
            }
        })
        let component;
        if (this.props.currentElement === "Descriptive Metrics CPU") {
            component = <DescriptiveCPU result={this._onresult} data={finalObjectFiltered} />
        } else if (this.props.currentElement === "Descriptive Metrics") {
            component = <DescriptiveGPU result={this._onresult} data={finalObjectFiltered} />
        }
        console.log(finalObjectFiltered)
        return (
            <div>
                <Box>	  
                    <Tiles>
                    <h2 style={{paddingTop: "5px"}}><strong>Results</strong></h2>
                        <Tiles fill={true} flush={true} justify="center" responsive={true} selectable={true} size={"small"} onSelect={this._onSelect}>
                            {(time) && <Tile pad={{"horizontal": "medium"}} colorIndex="light-1" key={0} style={{maxWidth: "300px"}}>
                                <Box pad="small" colorIndex="light">
                                    <Box align="center">
                                    <Value value={`${time2digits} ms`}
                                        label='Performance'
                                        size='medium'
                                        responsive={true}
                                    />
                                    </Box>
                                </Box>	
                            </Tile>}
                            
                        </Tiles>
                    </Tiles>
                </Box>  

                <Table
                selectable={true}
                onSelect={this._onSelect.bind(this)}>
                    <TableHeader labels={['Name', 'Count', 'Min', 'Max', 'Range', 'Mean', 'Variance']}/>
                    <tbody>
                        {iterator.map((input, index)=> {
                            return (
                                <TableRow>
                                <td>
                                {finalNameFiltered[index]}
                                </td>
                                <td>
                                {input.count}
                                </td>
                                <td>
                                {input.min}
                                </td>
                                <td>
                                {input.max}
                                </td>
                                <td>
                                {input.range}
                                </td>
                                <td>
                                {input.mean ? this._set2digits(input.mean) : "NA"}
                                </td>
                                <td>
                                {input.variance ? this._set2digits(input.variance) : "NA"}
                                </td>
                            </TableRow>
                            )
                        })}
                    </tbody>
                </Table>
                 {(showcomponent) && <DescriptiveGPU result={this._onresult} data={finalObjectFiltered} />}
            </div>
        );
    }
}

//<LinealRegression xs={this.props.dataObject[0]} ys={this.props.dataObject[1]} x={x} result={this._onresult} predict={this._onpredict}/>
export default BubbleSample;



// WEBPACK FOOTER //
// ./src/samples/run/descrstat.js